import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-opi-project-evaluation-draft-tip-report',
    templateUrl: './opiProjectEvaluationDraftTipReport.html',
    styleUrls: ['../../reports.css', './opiProjectEvaluationDraftTipReport.css']
})

export class OPIProjectEvaluationDraftTIPReportComponent implements OnInit {

    isGenerating = false;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;
    reportParams: IReportParams = {
        countyNumber: null,
        districtNumber: null,
        municipalId: null,
        congressDistrictNumber: null,
        senateDistrictNumber: null,
        houseDistrictNumber: null,
        projectIds: null,
        tipType: 'A',
        planningPartner: null
    };
    planningPartnerShortName: string;
    countyMunicipalityCode: string;
    reportData;
    todaysDate = new Date().toDateString();
    totalMiles;
    searchLocation;

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : OPI Project Evaluation Draft TIP Report');
    }

    async ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            const params = JSON.parse(window.localStorage.getItem(x.get('id')));
            this.reportParams.countyNumber = params.countyNumber;
            this.reportParams.districtNumber = params.districtNumber;
            this.reportParams.congressDistrictNumber = params.congressDistrictNumber;
            this.reportParams.senateDistrictNumber = params.senateDistrictNumber;
            this.reportParams.houseDistrictNumber = params.houseDistrictNumber;
            this.reportParams.projectIds = params.projectIds;
            this.reportParams.planningPartner = params.planningPartnerShortName;
            this.planningPartnerShortName = params.planningPartnerShortName;
            this.countyMunicipalityCode = params.countyMunicipalityCode;
            this.loadReport();
        });
    }

    private loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getOPIProjectEvaluationDraftTIPReportData(this.reportParams).then((reportData) => {
            this.reportData = reportData;
            this.calculateTotalMiles();
            this.getSearchLocation();
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
    // split municipality code out for report
    private getMunicipalityCode() {
        if (this.countyMunicipalityCode) {
            const splitIndex = 2;
            return this.countyMunicipalityCode.substring(splitIndex);
        } else {
            return undefined;
        }
    }
    private calculateTotalMiles() {
        let total = 0;
        const data = this.reportData.projectEvaluationSummary;
        for (const key in data) {
            if (data[key].miles) {
                total += parseFloat(data[key].miles);
            }
        }
        this.totalMiles = total.toFixed(2);
    }
    private async getSearchLocation() {
        if (this.reportParams.countyNumber) {
            this.searchLocation = await this.reportHelper.getCountyNameFromId(parseInt(this.reportParams.countyNumber, 10));
        }
        if (this.reportParams.districtNumber) {
            this.searchLocation = 'District ' + this.reportParams.districtNumber;
        }
        if (this.reportParams.municipalId) {
            this.searchLocation = await this.reportHelper.getMunicipalNameFromId([this.reportParams.countyNumber], parseInt(this.reportParams.municipalId, 10));
        }
        if (this.reportParams.congressDistrictNumber) {
            await this.reportHelper.getCongressionalDistrictByName(parseInt(this.reportParams.congressDistrictNumber, 10)).then((data: any) => {
                this.searchLocation = data.title;
            });
        }
        if (this.reportParams.senateDistrictNumber) {
            await this.reportHelper.getSenateDistrictByName(parseInt(this.reportParams.senateDistrictNumber, 10)).then((data: any) => {
                this.searchLocation = data.title;
            });
        }
        if (this.reportParams.houseDistrictNumber) {
            await this.reportHelper.getHouseDistrictByName(parseInt(this.reportParams.houseDistrictNumber, 10)).then((data: any) => {
                this.searchLocation = data.title;
            });
        }
        if (this.planningPartnerShortName) {
            this.searchLocation = this.planningPartnerShortName + '(MPO/RPO)';
        }
    }
}

interface IReportParams {
    countyNumber: string;
    districtNumber: string;
    municipalId: string;
    congressDistrictNumber: string;
    senateDistrictNumber: string;
    houseDistrictNumber: string;
    projectIds: number[];
    tipType: string;
    planningPartner: string;
}
